import React from "react";
import { NavLink } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import RouteIcon from "@mui/icons-material/Route";

const NAV_ITEMS = [
  {
    to: "/orders",
    label: "Orders",
    icon: LocalShippingOutlinedIcon,
  },
  {
    to: "/routes",
    label: "Routes",
    icon: RouteIcon,
  },
];

const glassShellSx = {
  width: 72,
  flex: 1,
  minHeight: 0,
  alignSelf: "stretch",
  display: "flex",
  flexDirection: "column" as const,
  alignItems: "center",
  py: 1.5,
  gap: 1,
  borderRadius: "0 20px 20px 0",
  bgcolor: "rgba(255, 255, 255, 0.58)",
  backdropFilter: "blur(16px)",
  WebkitBackdropFilter: "blur(16px)",
  border: "1px solid rgba(255, 255, 255, 0.82)",
  borderLeft: "none",
  boxShadow:
    "4px 0 28px rgba(15, 23, 42, 0.07), 0 4px 12px rgba(15, 23, 42, 0.04)",
};

const tabBaseSx = {
  width: 56,
  minHeight: 96,
  display: "flex",
  flexDirection: "column" as const,
  alignItems: "center",
  justifyContent: "center",
  gap: 0.75,
  px: 0.5,
  py: 1.25,
  borderRadius: "14px",
  color: "#64748b",
  textDecoration: "none",
  transition: "all 0.2s ease",
};

export function AppSidebar() {
  return (
    <Box component="nav" aria-label="Main navigation" sx={glassShellSx}>
      {NAV_ITEMS.map(({ to, label, icon: Icon }) => (
        <NavLink key={to} to={to} style={{ textDecoration: "none" }}>
          {({ isActive }) => (
            <Box
              sx={{
                ...tabBaseSx,
                ...(isActive
                  ? {
                      bgcolor: "#ffffff",
                      color: "#5fa67a",
                      boxShadow:
                        "0 4px 16px rgba(15, 23, 42, 0.08), 0 1px 4px rgba(15, 23, 42, 0.04)",
                      border: "1px solid rgba(229, 233, 239, 0.9)",
                    }
                  : {
                      bgcolor: "transparent",
                      border: "1px solid transparent",
                      "&:hover": {
                        bgcolor: "rgba(255, 255, 255, 0.45)",
                        color: "#475569",
                      },
                    }),
              }}
            >
              <Icon sx={{ fontSize: 22, flexShrink: 0 }} />
              <Typography
                sx={{
                  writingMode: "vertical-rl",
                  transform: "rotate(180deg)",
                  fontSize: "0.68rem",
                  fontWeight: 700,
                  letterSpacing: "0.06em",
                  textTransform: "uppercase",
                  lineHeight: 1,
                  userSelect: "none",
                  whiteSpace: "nowrap",
                }}
              >
                {label}
              </Typography>
            </Box>
          )}
        </NavLink>
      ))}
    </Box>
  );
}
